import { AxiosResponse } from 'axios';
import { buildPath } from '../lib/url';
import { backendClient as client } from './clients';
import { ListOfValuesReadDTO } from './dto';
import { GetManyPaged } from './types';

const RESOURCE_PATH = 'meetings';

export const getMeetings: GetManyPaged<ListOfValuesReadDTO> = async ({ filter, page, size, sort, config } = {}) =>
    client
        .get(buildPath([RESOURCE_PATH]), { ...config, params: { filter, page, size, sort: sort || 'label,asc' } })
        .then((response: AxiosResponse) => response.data);
